<!-- TodaySummary.vue -->
<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div>
					<el-form label-position="top" label-width="100px">
						<div class="row">
							<div class="col-md-6">	
								<el-form-item label="Station">
									<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
										<el-option v-for="item7 in spbu.list" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-6">	
								<el-form-item label="Date Range:">
									<div class="block">								
										<el-date-picker
										v-model="dateRange"
										type="daterange"
										align="right"
										size="small" 
										unlink-panels
										range-separator="-"
										start-placeholder="Start date"
										end-placeholder="End date"
										format="yyyy-MM-dd"
										value-format="yyyy-MM-dd"
										:picker-options="pickerOptions">
										</el-date-picker>
									</div>
								</el-form-item>
							</div>

							<div class="col-md-3" v-if="is2024OrBelow">
								<el-form-item label="Sales Area">
									<el-radio-group v-model="area" size="small" name="area">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-6" v-if="is2025OrAbove">
								<el-form-item label="Region">
									<el-radio-group v-model="region" size="small" name="region">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-3">
								<el-form-item label="Posting Status">
									<el-radio-group v-model="status" size="small" name="status">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-6" v-if="tabName == 'shift_settlement'">
								<el-form-item label="Settlement Shift">
									<el-radio-group v-model="shift" size="small" name="shift">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.shift" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-6" v-if="tabName == 'transaction'">
								<el-form-item label="Payment Method">
									<el-radio-group v-model="payment" size="small" name="payment">
										<el-radio-button :label="item5.value" v-for="(item5, index5) in options.payment" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
									</el-radio-group>
								</el-form-item>
							</div>

							<div class="col-md-2">	
								<el-form-item label=" ">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</el-form-item>
							</div>
						</div>
						<div class="row"></div>
					</el-form>
				</div>

				<div class="row" v-if="false">
                    <div class="col-md-3 mb-2 mt-2">
                        <el-checkbox v-model="showchart">Show Chart</el-checkbox>
                    </div>

					<div class="col-md-8 mt-2" v-if="showchart">
						<el-radio-group v-model="chartview" size="small" name="chartview">
							<el-radio-button :label="item5.value" v-for="(item5, index5) in options.chartview" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
						</el-radio-group>
					</div>
                </div>

				<div class="row" v-if="showchart">
					<div class="col-md-12">
						<div>
                            <BarChart :data="chartdata" :width="500" :height="380"/>
                            <Loader v-if="loading.table" />
                        </div>
					</div>
				</div>

				<div class="mt-0" v-if="false">
					<ReportResultTable :reportname="'PettyCashReport'"  :reportdata="reportdata" :loading="loading.table" :issuccess="loading.isSuccess" />
				</div>

				<div class="mt-1">
					<ReportResultTableServerSide
						:apiEndpoint="endPoint"
						:reportname="'Posting BOS ' + this.tabLabel"
						@on-click-row="handleRowClick"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, AppColors, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

import TodaySummaryTable from '@/views/pages/Finance/CashDeposit/Report/TodaySummaryTable.vue'
import ReportResultTableServerSide from '@/views/pages/ReportResultTableServerSide.vue'

export default {
	extends: Finance,
	components: { 
        ReportResultTable,
		BarChart,
		Loader,
        //TodaySummaryTable,
		ReportResultTableServerSide,
	},
	props: ['tabIndex','tabName', 'tabLabel'],
	data(){
		return {
            urlRequestParams: '',
            reportdata: { data: [] },  // Ensure it's an object with a 'data' property
            stationid: '',
            plant: '',
			status: '',
			payment: '',
			shift: '',
            spbu: {
                list: [],
            },
			options: {
				area:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
				],
				region:[
					{ value: "", name: "ALL" }, 
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
					{ value: "4", name: "4" }, 
					{ value: "5", name: "5" }, 
					{ value: "6", name: "6" }, 
					{ value: "7", name: "7" }, 
				],
				chartview:[
					{ value: "summary_unit", name: "Summary Unit Qty" }, 
					{ value: "monthly_user", name: "Summary By User" }, 
					{ value: "posting_status", name: "Posting Status Qty" }, 
				],
				status:[
					{ value: "", name: "All" }, 
					{ value: "posted", name: "Sudah Posting" }, 
					{ value: "not_posted", name: "Belum Posting" }, 
				],
				payment: [
					{ value: "", name: "All" }, 
					{ value: "EDC", name: "EDC" }, 
					{ value: "RFID", name: "RFID" }, 
					{ value: "VOUCHER", name: "VOUCHER" }, 
				],
				shift: [
					{ value: "", name: "All" }, 
					{ value: "1", name: "1" }, 
					{ value: "2", name: "2" }, 
					{ value: "3", name: "3" }, 
				],
			},
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().bulanSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().bulanSekarang, this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			year: this.$route.query.year ? this.$route.query.year : Penanggalan().tahun,
			month: this.$route.query.month ? this.$route.query.month : Penanggalan().bulan,
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			coaname: '',

			chartdata: [],
			showchart: false,
			chartview: 'summary_unit',
			stacked: false,

			endPoint: '',

			is2024OrBelow: false,
			is2025OrAbove: true,

        }
    },
    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList();
        //this.getData();
    },
	watch: {
		chartview() {
			this.setChartView();
		},
		dateRange(newValue, oldValue) {
			let yearCategory = this.getYearCategory(newValue);
			// && is2024OrBelow
			if(yearCategory == 1) {
				//year 2025 or above
				this.is2025OrAbove = true;
				this.is2024OrBelow = false;

				this.region = '';
				this.area = '';
				//this.salescharttype = 'saleschartregion'
			} else if(yearCategory == 2) {
				//year 2024 or below
				this.is2024OrBelow = true;
				this.is2025OrAbove = false;

				this.region = '';
				this.area = '';
				//this.salescharttype = 'saleschartarea'
			} else {
				//year mixed
				this.is2024OrBelow = true;
				this.is2025OrAbove = true;

				this.region = '';
				this.area = '';
				//this.salescharttype = 'saleschartall'
			} 
		},
	},
    methods: {
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},
        getData() {
            this.urlRequestParams=Config().apiURL
			if(this.tabName == 'edc')
				this.urlRequestParams+='/v1/maintenance/postingedcdetail?'
			else if(this.tabName == 'transaction')
				this.urlRequestParams+='/v1/maintenance/Postingtransaction?'
			else
				this.urlRequestParams+='/v1/maintenance/postingshiftsettlement?'

            this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
            this.urlRequestParams+='&stationid='+this.stationid
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&area='+this.area
            this.urlRequestParams+='&region='+this.region

            this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&payment='+this.payment
            this.urlRequestParams+='&shift='+this.shift

			this.endPoint = this.urlRequestParams

			//console.log('endPoint: ' + this.endPoint);

			/*
			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.loading.isSuccess = true;
					this.reportdata = response.data;  // Update the data property of reportdata

					this.setChartView();
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
				*/
        },
		setChartView() {
			let label = 'MonthName';
			let legend = 'Username';
			let amount = 'Cnt';
			this.stacked = false;

			if(this.chartview == 'summary_unit') {
				label = 'MonthName';
				legend = 'Legend';
				amount = 'Cnt';
			} else if(this.chartview == 'monthly_user') {
				label = 'MonthName';
				legend = 'Username';
				amount = 'Cnt';
				this.stacked = true;
			} else if(this.chartview == 'posting_status') {
				label = 'MonthName';
				legend = 'PostingStatus';
				amount = 'Cnt';
			} 

			this.chartdata = this.processBarChart(this.reportdata.data, legend, "", amount, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
		},

		handleRowClick(row) {
			console.log("Row selected:", row);
		},
		
        applyFilter() {
            this.getData()
        },
    }
}
</script>
